<h2 class="page-heading">Search Recordings</h2>

<div>
    <app-response-text
    [lambdaMessage]="lambdaMessage"
    [lambdaError]="lambdaError">
    </app-response-text>
        
    <mat-tab-group >
        <mat-tab *ngIf="auth.memberOf.includes(policySearchRole)" label="Policy Search">
            <app-policy-search></app-policy-search>
        </mat-tab>
        <mat-tab *ngIf="auth.memberOf.includes(claimSearchRole)" label="Claim Search">
            <app-claim-search></app-claim-search>
        </mat-tab>
    </mat-tab-group>
</div>